// single source of truth for the build identifier shown on the pairing
// screen and, per the player-page version marker, logged/exposed there too -
// two separate hardcoded copies of this previously drifted from package.json
// and from each other.
export const CLIENT = "screencloud";
export const VERSION = "1.1.0";
